/**
 * only front page
 */
import { scrollTrigger } from "../common/_scrollTrigger";
import { loadingFunc } from "../common/_loading";

export const homeFunc = () => {

  // ローディングアニメーション
  loadingFunc();

  let lastInnerWidth = window.innerWidth ;
  window.addEventListener( "resize", function () {
    if ( lastInnerWidth != window.innerWidth ) {
      lastInnerWidth = window.innerWidth ;
      this.setTimeout( function () {
        this.window.location.reload();
      }, 100 );
    }
  } ) ;

  /**
   * スクロールが関係するアニメーション
   */
  {
    {
      const img1 = document.querySelector( '.p-background-img__type1' );
      const img2 = document.querySelector( '.p-background-img__type2' );

      const philosophy = document.querySelector( '.p-home-philosophy' );

      const fixed1 = document.querySelector( '.p-home-fixed1' );
      const fixed2 = document.querySelector( '.p-home-fixed2' );
      scrollTrigger( fixed1, 100 );
      scrollTrigger( fixed2, 100 );

      let scrollY;

      const elDesc = document.querySelector( '.p-home-description' );
      const header = document.querySelector( '.l-header' );
      const bg     = document.querySelector( '.p-background__inner' );
      const bgImg  = document.querySelector( '.p-background-img__inner' );
      const bgImgH = bgImg.offsetHeight;
      let trigger1 = elDesc.offsetHeight + elDesc.offsetTop - window.innerHeight + header.offsetHeight;
      let trigger2 = fixed2.offsetTop - window.innerHeight + header.offsetHeight;
      let sa = 0;
      let scrollRate = 0;

      let maxBright = 300;
      let minBright = 100;
      let brightRate = 0;

      let maxScale = 110;
      let minScale = 100;
      let scaleRate = 0;

      window.addEventListener( 'scroll', function () {
        scrollY = window.scrollY;

        if ( img1.classList.contains( 'is--show' ) && !( img2.classList.contains( 'is--show' ) ) )
        {
          philosophy.classList.remove( 'is--bgNone' );

          sa = scrollY - trigger1;

          // 「.p-background-img__type1」のエフェクトを変化
          if ( fixed1.classList.contains( 'is--scrollTrigger' ) ) {
            //bg.style.top = '-' + sa + 'px';
            bg.style.transform = 'translate3d(0, -' + sa + 'px, 0)';
            scrollRate = sa / bgImgH;
            brightRate = maxBright - ( ( maxBright - minBright ) * scrollRate );
            if ( brightRate < 300 && brightRate > 100 ) {
              bgImg.style.filter = 'brightness( ' + brightRate + '% )';
              bgImg.style.opacity = scrollRate;
            }
          } else {
            // bg.style.top = '0';
            bg.style.transform = 'translate3d(0, 0, 0)';
          }

          // 「.p-background-img__type1」のスケールを変化
          if ( fixed1.classList.contains( 'is--scrollTrigger' ) ) {
            scrollRate = sa / ( fixed1.offsetHeight + this.innerHeight );
            scaleRate = maxScale - ( ( maxScale - minScale ) * scrollRate );
            bgImg.style.transform = 'scale(' + scaleRate + '%)';
          }
        } else
        {
          // Philosophy がTOPに来たら、背景を固定
          if ( philosophy.classList.contains( 'is--scrollTrigger' ) ) {
            philosophy.classList.add( 'is--bgNone' );
            // bg.style.top = '0';
            bg.style.transform = 'translate3d(0, 0, 0)';
          } else {
            philosophy.classList.remove( 'is--bgNone' );
          }

          if ( fixed2.classList.contains( 'is--scrollTrigger' ) ) {
            sa = scrollY - trigger2;

            // 「.p-background-img__type2」のエフェクトを変化
            if ( fixed2.classList.contains( 'is--scrollTrigger' ) ) {
              // bg.style.top = '-' + sa + 'px';
              bg.style.transform = 'translate3d(0, -' + sa + 'px, 0)';
              scrollRate = sa / bgImgH;
              brightRate = maxBright - ( ( maxBright - minBright ) * scrollRate );
              if ( brightRate < 300 && brightRate > 100 ) {
                bgImg.style.filter = 'brightness( ' + brightRate + '% )';
                bgImg.style.opacity = scrollRate;
              }
            } else {
              // bg.style.top = '0';
              bg.style.transform = 'translate3d(0, 0, 0)';
            }

            // 「.p-background-img__type2」のスケールを変化
            if ( fixed2.classList.contains( 'is--scrollTrigger' ) ) {
              scrollRate = sa / ( fixed2.offsetHeight + this.innerHeight );
              scaleRate = maxScale - ( ( maxScale - minScale ) * scrollRate );
              bgImg.style.transform = 'scale(' + scaleRate + '%)';
            }
          }
        }
      }, {passive: true} );
    }
  }

  /**
   * 固定背景の切り替え
   */
  {
    const bg  = document.querySelector( '.p-background' );
    const bg1 = document.querySelector( '.p-background__type1' );
    const bg2 = document.querySelector( '.p-background__type2' );
    const bg3 = document.querySelector( '.p-background__type3' );

    const plan = document.querySelector( '.p-home-plan' );
    const report = document.querySelector( '.p-home-report' );
    const reportBottom = document.querySelector( '.p-home-report__bottom' );
    scrollTrigger( plan, 50 );
    scrollTrigger( report, 50 );
    scrollTrigger( reportBottom, 50 );

    addEventListener( 'scroll', function () {

      if ( plan.classList.contains( 'is--scrollTrigger' ) && ! ( report.classList.contains( 'is--scrollTrigger' ) ) ) {
        bg1.classList.remove( 'is--show' );
        bg2.classList.add( 'is--show' );
        bg3.classList.remove( 'is--show' );
        bg.classList.add( 'is--bgWhite' );
      } else if ( report.classList.contains( 'is--scrollTrigger' ) && ! ( reportBottom.classList.contains( 'is--scrollTrigger' ) ) ) {
        bg1.classList.remove( 'is--show' );
        bg2.classList.remove( 'is--show' );
        bg3.classList.add( 'is--show' );
        bg.classList.add( 'is--bgWhite' );
      } else if ( reportBottom.classList.contains( 'is--scrollTrigger' ) ) {
        bg1.classList.add( 'is--show' );
        bg2.classList.remove( 'is--show' );
        bg3.classList.remove( 'is--show' );
        bg.classList.add( 'is--bgWhite' );
      } else {
        bg1.classList.add( 'is--show' );
        bg2.classList.remove( 'is--show' );
        bg3.classList.remove( 'is--show' );
        bg.classList.remove( 'is--bgWhite' );
      }
    } );
  }

  /**
   * 「.p-background-img__type1」「.p-background-img__type2」の切り替え
   */
  {
    const philosophy = document.querySelector( '.p-home-philosophy' );
    const bg2        = document.querySelector( '.p-background-img__type2' );

    scrollTrigger( philosophy, -10 );

    addEventListener( 'scroll', function () {
      if ( philosophy.classList.contains( 'is--scrollTrigger' ) ) {
        bg2.classList.add( 'is--show' );
      } else {
        bg2.classList.remove( 'is--show' );
      }
    }, {passive: true} );
  }

  /**
   * scrollTrigger
   */
  {
    // ディスクリプションエリア
    const desc = document.querySelector( '.p-home-description' );
    scrollTrigger( desc, 50 );

    // philosophy
    const philosophy = document.querySelector( '.p-home-philosophy' );
    scrollTrigger( philosophy, 0 );
  }
}
